import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ roles, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-slate-500" data-testid="auth-loading">
        <div className="h-8 w-8 border-2 border-[#0A2540] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (roles && roles.length && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "reviewer" ? "/reviewer" : "/agent";
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
